import { useCallback, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BrowserView, MobileView } from 'react-device-detect';

import Navigation from "./navigation";
import Sidebar from "./sidebar";
import Footer from "./footer";
import MobileMenu from "./sidebar/mobile";

const SIDEBAR_WIDTH_KEY = "matters.client.sidebar.width";
const MIN_SIDEBAR_WIDTH = 120;
const MAX_SIDEBAR_WIDTH = 360;
const DEFAULT_SIDEBAR_WIDTH = 150;

const clampSidebarWidth = (width) => Math.min(MAX_SIDEBAR_WIDTH, Math.max(MIN_SIDEBAR_WIDTH, width));

const Layout = ({ children }) => {
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const stored = Number(localStorage.getItem(SIDEBAR_WIDTH_KEY));
    return Number.isFinite(stored) && stored > 0
      ? clampSidebarWidth(stored)
      : DEFAULT_SIDEBAR_WIDTH;
  });

  useEffect(() => {
    document.body.classList.add('h-100');
    const root = document.getElementById('root');
    if (root) {
      root.classList.add('h-100');
    }
    return () => {
      document.body.classList.remove('h-100');
      if (root) {
        root.classList.remove('h-100');
      }
    };
  }, []);

  const onResizeMouseDown = useCallback((event) => {
    event.preventDefault();

    const startX = event.clientX;
    const startWidth = sidebarWidth;
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";

    const onMouseMove = (moveEvent) => {
      const nextWidth = clampSidebarWidth(startWidth + moveEvent.clientX - startX);
      setSidebarWidth(nextWidth);
      localStorage.setItem(SIDEBAR_WIDTH_KEY, String(nextWidth));
    };

    const onMouseUp = () => {
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  }, [sidebarWidth]);

  const onResizeKeyDown = useCallback((event) => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();

    const nextWidth = event.key === "Home"
      ? MIN_SIDEBAR_WIDTH
      : event.key === "End"
        ? MAX_SIDEBAR_WIDTH
        : clampSidebarWidth(sidebarWidth + (event.key === "ArrowLeft" ? -10 : 10));

    setSidebarWidth(nextWidth);
    localStorage.setItem(SIDEBAR_WIDTH_KEY, String(nextWidth));
  }, [sidebarWidth]);

  return (
    <>
      <BrowserView>
        <Navigation />
        <main>
          <Container>
            <Row className="flex-nowrap align-items-stretch" style={{zIndex: "1"}}>
              <Sidebar width={sidebarWidth} />
              <div
                aria-label="Resize navigation"
                role="separator"
                tabIndex={0}
                onMouseDown={onResizeMouseDown}
                onKeyDown={onResizeKeyDown}
                style={{
                  width: "4px",
                  flex: "0 0 4px",
                  minWidth: "4px",
                  maxWidth: "4px",
                  boxSizing: "border-box",
                  padding: 0,
                  margin: 0,
                  cursor: "col-resize",
                  background: "linear-gradient(to right, #d1d5db 0, #d1d5db 1px, #f3f4f6 1px, #f3f4f6 3px, #d1d5db 3px, #d1d5db 4px)",
                  display: "flex",
                  alignSelf: "stretch",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 3,
                }}
              >
                <span
                  aria-hidden="true"
                  style={{
                    width: "1px",
                    height: "36px",
                    background: "#6b7280",
                  }}
                />
              </div>
              <Col
                id="contentArea"
                style={{
                  backgroundColor: "white",
                  zIndex: "2",
                  alignSelf: "stretch",
                  minHeight: "100%",
                }}
              >
                {children}
              </Col>
            </Row>
          </Container>
        </main>
        <Footer />
      </BrowserView>
      <MobileView>
        <MobileMenu />
        {children}
      </MobileView>
    </>
  );
};
export default Layout;
